export default "__VITE_ASSET__DvybE5tZ__"